module.exports = __webpack_public_path__ + "media/images/favicon-16x16-ec25c3ed.png";